module.exports = __webpack_public_path__ + "static/media/img-adminmaincon.d8d39bda.png";